'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccessibleTextField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utilsBrowser = require('@bibliocommons/utils-browser');

var _sharedFieldErrorWrapper = require('@bibliocommons/shared-field-error-wrapper');

var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseCharacterCount = require('@bibliocommons/base-character-count');

var _baseCharacterCount2 = _interopRequireDefault(_baseCharacterCount);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

require('../styles/AccessibleTextField.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessibleTextField = exports.AccessibleTextField = function (_BcReactComponent) {
  _inherits(AccessibleTextField, _BcReactComponent);

  function AccessibleTextField(props) {
    _classCallCheck(this, AccessibleTextField);

    var _this = _possibleConstructorReturn(this, (AccessibleTextField.__proto__ || Object.getPrototypeOf(AccessibleTextField)).call(this, props));

    _this.bindAll('handleChange', 'handlePaste');
    return _this;
  }

  _createClass(AccessibleTextField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // for testing purposes.
    }
  }, {
    key: 'handleChange',
    value: function handleChange() {
      var value = this._textInput.value;
      if (this.props.handleChange) {
        this.props.handleChange(value);
      }
    }
  }, {
    key: 'handlePaste',
    value: function handlePaste(e) {
      var value = (0, _utilsBrowser.getTextFromPasteEvent)(e);
      if (this.props.handlePaste) {
        this.props.handlePaste(value);
      }
    }
  }, {
    key: 'renderInfo',
    value: function renderInfo() {
      return this.props.info ? _react2.default.createElement(
        'div',
        { className: 'info' },
        this.props.info
      ) : null;
    }
  }, {
    key: 'renderInputIcon',
    value: function renderInputIcon() {
      return this.props.inputIcon ? this.props.inputIcon : null;
    }
  }, {
    key: 'renderCharacterCount',
    value: function renderCharacterCount() {
      var _props = this.props,
          value = _props.value,
          suggestedMaxLength = _props.suggestedMaxLength,
          maxLength = _props.maxLength,
          characterCountSrOnly = _props.characterCountSrOnly;

      if (suggestedMaxLength || maxLength) {
        return _react2.default.createElement(_baseCharacterCount2.default, {
          screenReaderOnly: characterCountSrOnly,
          count: value ? value.length : 0,
          limit: suggestedMaxLength || maxLength });
      }

      return null;
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this._textInput) {
        this._textInput.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-accessible-text-field clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'input-holder' },
          _react2.default.createElement('input', {
            id: this.props.id,
            type: this.props.type,
            className: 'form-control ' + this.props.className,
            ref: function ref(el) {
              _this2._textInput = el;
            },
            'aria-labelledby': this.props.labelledById,
            'aria-describedby': this.props.describedById,
            disabled: this.props.disabled,
            onChange: this.handleChange,
            onPaste: this.handlePaste,
            onFocus: this.props.handleFocus,
            onBlur: this.props.handleBlur,
            maxLength: this.props.maxLength,
            name: this.props.name,
            pattern: this.props.pattern,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            required: this.props.required,
            value: this.props.value,
            autoFocus: this.props.focus,
            'data-test-id': this.props.testId }),
          this.renderInputIcon()
        ),
        this.renderInfo(),
        this.renderCharacterCount()
      );
    }
  }]);

  return AccessibleTextField;
}(_baseBcReactComponent2.default);

var WrappedAccessibleTextField = (0, _sharedFieldErrorWrapper2.default)(AccessibleTextField);

WrappedAccessibleTextField.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  describedById: _react.PropTypes.string.isRequired,
  disabled: _react.PropTypes.bool,
  handleChange: _react.PropTypes.func,
  handlePaste: _react.PropTypes.func,
  handleBlur: _react.PropTypes.func,
  handleFocus: _react.PropTypes.func,
  info: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
  labelledById: _react.PropTypes.string.isRequired,
  showRemainingCharacterCount: _react.PropTypes.bool,
  suggestedMaxLength: _react.PropTypes.number,
  maxLength: _react.PropTypes.number,
  name: _react.PropTypes.string,
  pattern: _react.PropTypes.string,
  type: _react.PropTypes.string,
  focus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool,
  required: _react.PropTypes.bool,
  value: _react.PropTypes.string,
  testId: _react.PropTypes.string,
  characterCountSrOnly: _react.PropTypes.bool,
  inputIcon: _react.PropTypes.element,
  fieldErrors: _react.PropTypes.objectOf(_bcPropTypes.fieldErrorsShape),
  errorKey: _react.PropTypes.string
};

WrappedAccessibleTextField.defaultProps = {
  type: 'text'
};

exports.default = WrappedAccessibleTextField;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-text-field/lib/components/AccessibleTextField.component.js
// module id = 1013
// module chunks = 1